// Module
var code = "<html> <head></head> <body style=\"margin:0;padding:0\"> <div id=\"full-window-cta\"> <label>%openFullSizeLabel%</label> </div> </body> </html> ";
// Exports
export default code;